import { useMsal } from '@azure/msal-react';
import { loginSilentRequest } from 'src/config';

type LoginInput = {
  login: string;
};

export const useLoginInput = (): LoginInput => {
  const { accounts, instance } = useMsal();
  const login = accounts[0]?.username.split('@')[0]?.toUpperCase() || '';

  if (login === '') {
    void instance.acquireTokenRedirect(loginSilentRequest);
  }

  return { login };
};
